module.exports = "./img/82dd49abb1f78320b26ecd6639b4fda6.jpg";